module.exports = __webpack_public_path__ + "img/img_2.4f7673b4.png";